import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { Container } from "react-bootstrap";

import placeholder from "../../../assets/images/approach.svg";

const ApproachItem = ({ className, placeholder, title, text }) => {
  return (
    <div className={`approach-item ${className}`}>
      <div className="image-holder">
        <img src={placeholder} alt="placeholder" />
      </div>
      <div className="details">
        <h3 className="title">{title}</h3>
        <p className="text">{text}</p>
      </div>
    </div>
  );
};
const Approach = ({ approaches }) => {
  return (
    <div className="approach-section">
      <Container>
        <h1 className="section-title">Our Approach</h1>
        <div className="approach_list">
          {approaches &&
            approaches.map((item) => {
              return (
                <ApproachItem className={item.id} key={item.id} {...item} />
              );
            })}
        </div>
        <a href="#/" className="fit-check">
          Find out if your business is a fit →
        </a>
      </Container>
    </div>
  );
};
Approach.propTypes = {
  approaches: PropTypes.array,
};
Approach.defaultProps = {
  approaches: [
    {
      id: "empowered",
      placeholder,
      title: "Empowered by technology",
      text:
        "Our proprietary pricing engine enables us to give offers within a day.",
    },
    {
      id: "growth",
      placeholder,
      title: "Sustainable growth",
      text:
        "Our team of direct-to-consumer experts continue to build up the value of your brand.",
    },
    {
      id: "potential",
      placeholder,
      title: "Every business has potential",
      text:
        "Our pricing and operating technology enables us to buy businesses others might not.",
    },
    {
      id: "data",
      placeholder,
      title: "We’ll never sell your data",
      text:
        "Any data you share with us will only be used for accurate business valuations.",
    },
  ],
};
export default Approach;
